/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Channels_BarInputs */

const en_contact_channels_bar = /** @type {(inputs: Contact_Channels_BarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to reach us`)
};

const lv_contact_channels_bar = /** @type {(inputs: Contact_Channels_BarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kā ar mums sazināties`)
};

/**
* | output |
* | --- |
* | "How to reach us" |
*
* @param {Contact_Channels_BarInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_channels_bar = /** @type {((inputs?: Contact_Channels_BarInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Channels_BarInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_channels_bar(inputs)
	return en_contact_channels_bar(inputs)
});